export default "__VITE_ASSET__8e75f5f4__"